import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/qstar-logo.svg'


const _hoisted_1 = { class: "flex flex-col bg-gray-50 h-[100dvh] pt-20" }
const _hoisted_2 = { class: "flex flex-1 flex-col px-6 lg:px-8" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center sm:mx-auto sm:w-full sm:max-w-sm" }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "145",
    height: "78",
    src: _imports_0,
    alt: "qstar-logo"
  })
], -1)
const _hoisted_4 = {
  key: 0,
  class: "mt-10 sm:mx-auto sm:w-full sm:max-w-sm"
}
const _hoisted_5 = {
  class: "space-y-6",
  action: "#",
  method: "POST"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "userName",
  class: "block text-sm font-medium leading-6 text-secondary"
}, "Arbejdsnummer", -1)
const _hoisted_7 = {
  key: 0,
  class: "m-2 text-sm text-error peer-[&:not(:focus):invalid]:block"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "block text-sm font-medium leading-6 text-secondary"
}, "Adgangskode", -1)
const _hoisted_9 = {
  key: 0,
  class: "m-2 text-sm text-error peer-[&:not(:focus):invalid]:block"
}
const _hoisted_10 = { class: "xs:flex-row xs:space-y-0 flex flex-col items-center justify-between space-y-2 px-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createElementVNode("input", {
    id: "remember-me",
    name: "remember-me",
    type: "checkbox",
    class: "h-4 w-4 rounded border-gray-300 text-secondary focus:ring-secondary"
  }),
  /*#__PURE__*/_createElementVNode("label", {
    for: "remember-me",
    class: "ml-3 block text-sm text-gray-900"
  }, "Husk mig")
], -1)
const _hoisted_12 = { class: "text-sm" }
const _hoisted_13 = {
  key: 0,
  class: "animate-spin -ml-1 mr-3 h-5 w-5 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = {
  key: 1,
  class: "mt-10 sm:mx-auto sm:w-full sm:max-w-sm"
}
const _hoisted_18 = {
  class: "space-y-6",
  action: "#",
  method: "POST"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  for: "userName",
  class: "block text-sm font-medium leading-6 text-secondary"
}, "Arbejdsnummer", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "block text-sm font-medium leading-6 text-secondary"
}, "Mobilnummer", -1)
const _hoisted_21 = {
  key: 0,
  class: "m-2 text-sm text-error peer-[&:not(:focus):invalid]:block"
}
const _hoisted_22 = {
  key: 0,
  class: "animate-spin -ml-1 mr-3 h-5 w-5 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1)
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = { class: "xs:flex-row xs:space-y-0 flex flex-col items-center text-center justify-between space-y-2 px-2" }
const _hoisted_27 = { class: "text-sm w-full text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (!_ctx.showForgotPassword)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("form", _hoisted_5, [
              _createElementVNode("div", null, [
                _hoisted_6,
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    inputmode: "numeric",
                    id: "userName",
                    name: "userName",
                    type: "text",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginForm.userName) = $event)),
                    autocomplete: "userName",
                    required: "",
                    class: "peer block w-full rounded-md border-0 pb-1.5 pt-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-secondary sm:text-sm sm:leading-6"
                  }, null, 512), [
                    [_vModelText, _ctx.loginForm.userName]
                  ]),
                  (_ctx.loginForm.validateState === 500)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Angiv et gyldigt arbejdsnummer"))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_8,
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "password",
                    name: "password",
                    type: "password",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loginForm.password) = $event)),
                    autocomplete: "current-password",
                    required: "",
                    class: "peer block w-full rounded-md border-0 pb-1.5 pt-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-secondary sm:text-sm sm:leading-6"
                  }, null, 512), [
                    [_vModelText, _ctx.loginForm.password]
                  ]),
                  (_ctx.loginForm.loginState === 500)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Forkerte adgangsoplysninger"))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("a", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleClickForgotPassword())),
                    class: "font-medium text-secondary underline cursor-pointer hover:text-primary"
                  }, "Glemt din adgangskode?")
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("span", {
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args))),
                  class: _normalizeClass(["flex w-full justify-center text-center cursor-pointer rounded-md h-10 bg-secondary px-3 py-2 font-medium leading-6 text-white shadow-sm hover:bg-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondary", {'opacity-50' : _ctx.loginLoading}])
                }, [
                  (_ctx.loginLoading)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_13, _hoisted_16))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" Log ind ")
                      ], 64))
                ], 2)
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("form", _hoisted_18, [
              _createElementVNode("div", null, [
                _hoisted_19,
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "userName",
                    name: "userName",
                    type: "text",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.forgotPasswordForm.userName) = $event)),
                    autocomplete: "userName",
                    required: "",
                    class: "peer block w-full rounded-md border-0 pb-1.5 pt-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-secondary sm:text-sm sm:leading-6"
                  }, null, 512), [
                    [_vModelText, _ctx.forgotPasswordForm.userName]
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_20,
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "password",
                    name: "phone",
                    type: "text",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.forgotPasswordForm.phoneNumber) = $event)),
                    autocomplete: "current-password",
                    required: "",
                    class: "peer block w-full rounded-md border-0 pb-1.5 pt-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-secondary sm:text-sm sm:leading-6"
                  }, null, 512), [
                    [_vModelText, _ctx.forgotPasswordForm.phoneNumber]
                  ]),
                  (_ctx.forgotPasswordForm.responseState === 500)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, "Ugyldige oplysninger"))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("span", {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleSubmitForgotPassword())),
                  class: _normalizeClass(["flex w-full cursor-pointer justify-center h-10 rounded-md bg-secondary px-3 py-2 font-medium leading-6 text-white shadow-sm hover:bg-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondary", {'opacity-50': _ctx.forgotPasswordLoading}])
                }, [
                  (_ctx.forgotPasswordLoading)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_22, _hoisted_25))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" Send adgangskode på SMS ")
                      ], 64))
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("a", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleClickBackToLogin())),
                    class: "font-medium text-secondary cursor-pointer underline hover:text-primary"
                  }, "Tilbage til login")
                ])
              ])
            ])
          ]))
    ])
  ]))
}